import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { ScoreAndSummaryQuestionnaireItem } from './questionnaire'
import { PatAssessmentQuestionnaireItem } from '../../types/questionnaire'

// Score and Summary section questionnaire answer type mapping
export const SCORE_AND_SUMMARY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [PatAssessmentQuestionnaireItem.SCORE_AND_SUMMARY]: QuestionnaireAnswerType.GROUP,
  [ScoreAndSummaryQuestionnaireItem.SCORE_AND_SUMMARY_MODIFIER_A]: QuestionnaireAnswerType.DECIMAL,
  [ScoreAndSummaryQuestionnaireItem.SCORE_AND_SUMMARY_MODIFIER_B]: QuestionnaireAnswerType.DECIMAL,
  [ScoreAndSummaryQuestionnaireItem.SCORE_AND_SUMMARY_CNA_SKILLED_TASKS]:
    QuestionnaireAnswerType.DECIMAL,
  [ScoreAndSummaryQuestionnaireItem.SCORE_AND_SUMMARY_TOTAL]: QuestionnaireAnswerType.DECIMAL
}
